document.addEventListener("DOMContentLoaded", function () {
    let previousCartQuantity = 0;
    // Retrieve initial cart data
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            previousCartQuantity = getTotalQuantity(cart);
        })
        .catch(error => console.error("Failed to fetch cart data:", error));

    // Monitor cart changes
    const observer = new MutationObserver(() => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let currentQuantity = getTotalQuantity(cart);
                if (currentQuantity !== previousCartQuantity) {
                    location.reload(); // Reload the page if quantity changes
                }
                previousCartQuantity = currentQuantity;
            })
            .catch(error => console.error("Failed to fetch cart data:", error));
    });

    // Observe the element where cart quantity updates (cart items container)
    const cartContainer = document.querySelector('[data-cart-container]') || document.body;
    observer.observe(cartContainer, { childList: true, subtree: true });

    // Function to get the total quantity of items in the cart
    function getTotalQuantity(cart) {
        return cart.items.reduce((sum, item) => sum + item.quantity, 0);
    }
});